export default __webpack_public_path__ + "static/media/cd_dark.bfd28127.png";